import { useState } from 'react'
import { Form } from 'react-bootstrap'
import { FormikProvider, useFormik } from 'formik'
import { Text, SelectBox, Number, Email, File, DatePicker } from 'components/input_fields'
import { UpdateProfileSchema } from './ValidationSchema'
import { SaveButton } from 'components/buttons'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { updateProfile } from '../../../../redux/slices/users'
import { toggleUpdateModal, toggleBool } from '../../../../redux/slices/globalSlice'
import { addUpdateHandler } from 'utils'
import { useTranslation } from 'react-i18next'

export default function UpdateProfileForm() {

    const [spinner, setSpinner] = useState(false)
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const details = useSelector(state => state?.profile?.details)

    const gender_option = [
        { "value": 'Male', "label": 'Male' },
        { "value": 'Female', "label": 'Female' },
        { "value": 'Other', "label": 'Other' },
    ]

    const initialValues = {
        id: details?.id,
        first_name: details?.userInfo?.first_name,
        last_name: details?.userInfo?.last_name,
        gender: details?.userInfo?.gender,
        username: details?.user_name,
        email: details?.userInfo?.user_email,
        mobile_number: details?.userInfo?.user_mobile,
        dob: details?.userInfo?.dob && moment(details?.userInfo?.dob, 'YYYY-MM-DD').format('DD/MM/YYYY') || '',
        profile: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: UpdateProfileSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            // console.log("value", values)
            setSpinner(true)
            dispatch(updateProfile({ 'values': values })).then((res) => addUpdateHandler({
                res: res.payload,
                action,
                navigate,
                success_toast: res?.payload?.data?.message,
                wrong_toast: `${t('common.wrong')}`,
                navigate_route: '',
                spinner: setSpinner,
                toggle: () => {
                    dispatch(toggleUpdateModal());
                    dispatch(toggleBool());
                }
            }))
        },
    })

    return (
        <>
            <div className="container-fluid">
                <FormikProvider value={formik}>
                    <Form onSubmit={(e) => { e.preventDefault(); formik.handleSubmit(); }}>
                        <div className="row">

                            <div className="col-md-4">
                                <Text
                                    label_name={t('profile.fname')}
                                    mandatory={true}
                                    placeholder=''
                                    disabled={false}
                                    name='first_name'
                                    value={formik.values.first_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.first_name && formik.touched.first_name ? (<span className='field_error'>{formik.errors.first_name}</span>) : null}
                                />
                            </div>

                            <div className="col-md-4">
                                <Text
                                    label_name={t('profile.lname')}
                                    mandatory={true}
                                    placeholder=''
                                    disabled={false}
                                    name='last_name'
                                    value={formik.values.last_name}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.last_name && formik.touched.last_name ? (<span className='field_error'>{formik.errors.last_name}</span>) : null}
                                />
                            </div>

                            <div className="col-md-4">
                                <SelectBox
                                    label_name={t('profile.gender')}
                                    mandatory={true}
                                    placeholder=''
                                    disabled={false}
                                    option={gender_option}
                                    name='gender'
                                    value={formik.values.gender}
                                    onChange={(e) =>
                                        formik.setFieldValue('gender', e)
                                    }
                                    onBlur={() => formik.setFieldTouched("gender", true)}
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    error={formik.errors.gender && formik.touched.gender ? (<span className='field_error'>{formik.errors.gender}</span>) : null}
                                />
                            </div>

                            <div className="col-md-4">
                                <DatePicker
                                    label_name={t('profile.dob')}
                                    mandatory={false}
                                    placeholder=''
                                    name='dob'
                                    value={formik.values.dob}
                                    onChange={(date, dateString) => formik.setFieldValue('dob', dateString)}
                                    onBlur={() => formik.setFieldTouched('dob', true)}
                                    error={formik.errors.dob && formik.touched.dob ? (<span className='field_error'>{formik.errors.dob}</span>) : null}
                                />
                            </div>

                            <div className="col-md-4">
                                <Text
                                    label_name={t('profile.username')}
                                    mandatory={true}
                                    placeholder=''
                                    disabled={true}
                                    name='username'
                                    value={formik.values.username}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.username && formik.touched.username ? (<span className='field_error'>{formik.errors.username}</span>) : null}
                                />
                            </div>

                            <div className='col-md-4'>
                                <Number
                                    label_name={t('profile.mobile')}
                                    mandatory={true}
                                    placeholder=''
                                    disabled={false}
                                    name='mobile_number'
                                    value={formik.values.mobile_number}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.mobile_number && formik.touched.mobile_number ? (<span className='field_error'>{formik.errors.mobile_number}</span>) : null}
                                />
                            </div>

                            <div className="col-md-4">
                                <Email
                                    label_name={t('profile.email')}
                                    mandatory={true}
                                    placeholder=''
                                    disabled={false}
                                    name='email'
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.email && formik.touched.email ? (<span className='field_error'>{formik.errors.email}</span>) : null}
                                />
                            </div>

                            <div className="col-md-5">
                                <File
                                    label_name={t('profile.profile')}
                                    mandatory={false}
                                    disabled={false}
                                    name='profile'
                                    onChange={(e) =>
                                        formik.setFieldValue('profile', e.currentTarget.files[0])
                                    }
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.profile && formik.touched.profile ? (<span className='field_error'>{formik.errors.profile}</span>) : null}
                                    accept="image/jpg, image/jpeg, image/png"
                                />
                            </div>

                            <div className="col-md-12">
                                <div className="d-flex justify-content-end">
                                    <div className="col-lg-4">
                                        <SaveButton
                                            button_name={t('common.submit')}
                                            spinner={spinner}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Form>
                </FormikProvider>
            </div>
        </>
    )
}